export enum HookDappType {
  INTERNAL = 'INTERNAL',
  IFRAME = 'IFRAME',
}

export enum HookDappWalletCompatibility {
  EOA = 'EOA',
  SMART_CONTRACT = 'SMART_CONTRACT',
}

export const HOOK_DAPP_ID_LENGTH = 64

export const PERMIT_HOOK_DAPP_ID = 'cow-swap://libs/hook-dapp-lib/permit'
